export interface ShopNavbarMenuItem {
  label: string;
  value: string;
}

export interface ShopNavbarCategoryItem {
  label: string;
  value?: string;
  children?: readonly ShopNavbarMenuItem[];
}

export const DEFAULT_CATEGORY = "Bekleidung";
export const HEXE_CATEGORY = "Hexe";
export const KINDER_CATEGORY = "Kinder";
export const KINDER_MATERIAL_CATEGORY = "Stoff & Futter";
export const USED_CATEGORY = "Gebrauchte Artikel";
export const HEXE_PRODUCT_SLUGS = [
  "strohschuhe",
  "sockenpaar",
  "spitzenhose",
  "schuerze-wildsau",
  "maskentuch-massgeschneidert",
  "jacke-massgeschneidert",
  "rock-massgeschneidert",
  "nummer-maskentuch",
  "maske",
  "schweif-fuer-maske",
  "wappen",
  "polsterin",
  "maskenhalter",
  "handschweif",
] as const;
export const KINDER_PRODUCT_SLUGS = [
  "kinder-maskentuch-massgeschneidert",
  "kinder-maske",
  "strohschuhe",
  "kinder-jacke-massgeschneidert",
  "kinder-rock-massgeschneidert",
  "nummer-maskentuch",
  "kinder-schuerze-wildsau",
  "wappen",
  "handschweif",
  "kinder-t-shirt",
  "kinder-pullover",
  "kinder-hoodie",
  "kinder-fleecejacke",
] as const;
export const KINDER_MATERIAL_PRODUCT_SLUGS = [
  "stoff-gruen-rock",
  "stoff-braun-schuerze",
  "stoff-gruen-maskentuch",
  "futter-maskentuch",
] as const;
export const EXCLUDED_FROM_CLOTHING_TABS = [
  "sockenpaar",
  "spitzenhose",
  "schuerze-wildsau",
] as const;

export const SHOP_NAV_ITEMS: readonly ShopNavbarCategoryItem[] = [
  { label: "Herren", value: "Bekleidung Herren" },
  { label: "Damen", value: "Bekleidung Damen" },
  { label: "Hexe", value: HEXE_CATEGORY },
  { label: "Kinder", value: KINDER_CATEGORY },
  { label: "Stoff & Futter", value: KINDER_MATERIAL_CATEGORY },
  { label: "Gebrauchte Artikel", value: USED_CATEGORY },
  { label: "Accessoires", value: "Accessoires" },
] as const;

export const SHOP_SECTION_TO_CATEGORY: Record<string, string | null> = {
  herren: "Bekleidung Herren",
  damen: "Bekleidung Damen",
  hexe: HEXE_CATEGORY,
  kinder: KINDER_CATEGORY,
  "stoff-futter": KINDER_MATERIAL_CATEGORY,
  "gebrauchte-artikel": USED_CATEGORY,
  accessoires: "Accessoires",
};

export const CATEGORY_TO_SHOP_SECTION = new Map<string, string>(
  Object.entries(SHOP_SECTION_TO_CATEGORY)
    .filter((entry): entry is [string, string] => entry[1] !== null)
    .map(([section, category]) => [category, section])
);

export const CATEGORY_PAGE_LABELS: Record<string, string> = {
  "Bekleidung Herren": "Herren",
  "Bekleidung Damen": "Damen",
  [HEXE_CATEGORY]: "Hexe",
  [KINDER_CATEGORY]: "Kinder",
  [KINDER_MATERIAL_CATEGORY]: "Stoff & Futter",
  [USED_CATEGORY]: "Gebrauchte Artikel",
  Accessoires: "Accessoires",
};

export const getShopPathForCategory = (category: string, activeCategory?: string | null): string => {
  const section = CATEGORY_TO_SHOP_SECTION.get(category);
  if (!section) {
    return "/shop";
  }

  return activeCategory === category ? "/shop" : `/shop/${section}`;
};
